import { useState } from 'react';

interface BarItem {
  label: string;
  value: number;
  color: string;
}

interface HorizontalBarChartProps {
  items: BarItem[];
  formatValue?: (v: number) => string;
}

export const HorizontalBarChart = ({ items, formatValue }: HorizontalBarChartProps) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const maxValue = Math.max(...items.map((i) => i.value), 1);

  return (
    <div className="space-y-3">
      {items.map((item, i) => {
        const pct = (item.value / maxValue) * 100;
        const isHovered = hoveredIndex === i;
        const dimmed = hoveredIndex !== null && !isHovered;

        return (
          <div
            key={item.label}
            className="group cursor-pointer transition-opacity duration-150"
            style={{ opacity: dimmed ? 0.45 : 1 }}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-gray-700 font-medium truncate max-w-[60%]">
                {item.label}
              </span>
              <span className="text-sm font-semibold text-gray-900 tabular-nums">
                {formatValue ? formatValue(item.value) : item.value}
              </span>
            </div>
            <div className="h-3 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500 ease-out"
                style={{
                  width: `${pct}%`,
                  backgroundColor: item.color,
                  transform: isHovered ? 'scaleY(1.25)' : 'scaleY(1)',
                  transformOrigin: 'center',
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
